import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, CheckCircle2, CalendarDays } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function EvalAck() {
  const { token } = useParams();
  const [state, setState] = useState("loading");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    fetch(`${BACKEND}/api/public/eval-ack/${token}`, { method: "POST" })
      .then((r) => { if (!r.ok) throw new Error(); return r.json(); })
      .then((d) => { setInfo(d); setState("ok"); })
      .catch(() => setState("invalid"));
  }, [token]);

  if (state === "loading") return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-slate-300" /></div>;
  if (state === "invalid") return <div className="min-h-screen flex items-center justify-center text-slate-400 text-sm" data-testid="eval-ack-invalid">Invalid or expired link / 链接无效</div>;

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center px-4" data-testid="eval-ack-page">
      <div className="max-w-sm w-full bg-white rounded-2xl border border-slate-200 shadow-sm p-8 text-center">
        <CheckCircle2 className="h-14 w-14 text-emerald-500 mx-auto mb-3" />
        <p className="text-lg font-bold text-slate-800" data-testid="eval-ack-done">{info?.already ? "已确认过 / Already confirmed" : "确认成功 / Confirmed"}</p>
        <p className="text-sm text-slate-500 mt-2 flex items-center justify-center gap-1.5">
          <CalendarDays className="h-4 w-4 text-amber-500" />
          <span data-testid="eval-ack-info">{info?.evaluator}：已知晓 {info?.week} 周现场评估安排</span>
        </p>
        <p className="text-[11px] text-slate-300 mt-4">ALIGCUS Construction · 阿里建筑</p>
      </div>
    </div>
  );
}
